import { identifyUser, init } from 'legacy/common/utils/fullStory';
import { useEffect } from 'react';

type User = {
  id: string;
  email: string;
  name: string;
  country: string;
};

const useFullStory = (user: User) => {
  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (!user?.id) {
      return;
    }

    identifyUser(user?.id, user);
  }, [user?.id]);
};

export default useFullStory;
